module.exports = __webpack_public_path__ + "static/media/d2246193-2078-4bef-9e21-c1d73554de42.efd6fd49.jpeg";